export default import.meta.ROLLDOWN_FILE_URL_RRKfg0kWmbuEATq25BsovA